import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import Layout from '@/layout';
export default {
  path: '/followUpTasks',
  component: Layout,
  redirect: '/followUpTasks/question',
  name: 'followUpTasks',
  meta: {
    title: '随访任务管理',
    icon: 'jichu'
  },
  hidden: false,
  children: [{
    path: 'question',
    component: function component() {
      return import('@/views/followUpTasks/question/index.vue');
    },
    name: 'question',
    meta: {
      title: '问卷管理'
    },
    hidden: false
  }, {
    path: 'phoneSuiFang',
    component: function component() {
      return import('@/views/yewuAdmin/phoneSuiFang/index.vue');
    },
    name: 'phoneSuiFang',
    meta: {
      title: '电话管理'
    },
    hidden: false
  }, {
    path: 'myTelTask',
    component: function component() {
      return import('@/views/followUpTasks/myTelTask/index.vue');
    },
    name: 'myTelTask',
    meta: {
      title: '我的电话任务'
    },
    hidden: false
  }, {
    path: 'visitTask',
    component: function component() {
      return import('@/views/followUpTasks/visit/index.vue');
    },
    name: 'visitTask',
    meta: {
      title: '短信管理'
    },
    hidden: false
  }
  // {
  //   path: '/myVisitTask',
  //   component: () => import('@/views/followUpTasks/myVisit/index.vue'),
  //   name: 'myVisitTask',
  //   meta: {
  //     title: '我的上门任务',
  //   },
  //   hidden: false
  // }
  ]
};